module.exports = __webpack_public_path__ + "media/images/icons/yandex_zen_black-d552e65da91cdd453acd41ddf08ffe0d.svg";